import type { AudioBlockConfig } from '@lighthouse/core'
import { AudioVariant } from '@lighthouse/core'

export const AUDIO_VARIANT_DEFAULT_SIZE: Record<AudioVariant, AudioBlockConfig['breakPoint']['size']> = {
    [AudioVariant.bar]: {
        width: {
            size: 'fill'
        },
        height: {
            size: 24,
            unit: 'px'
        },
        overflow: 'visible'
    },
    [AudioVariant.voice]: {
        width: {
            size: 72,
            unit: 'px'
        },
        height: {
            size: 24,
            unit: 'px'
        },
        overflow: 'visible'
    },
    [AudioVariant.button]: {
        width: {
            size: 24,
            unit: 'px'
        },
        height: {
            size: 24,
            unit: 'px'
        },
        overflow: 'visible'
    }
}

export const generateAudioBlock = (mainBreakPoint: string, variant: AudioVariant = AudioVariant.bar): AudioBlockConfig => {
    return {
        variant,
        showDuration: true,
        isLoop: false,
        preload: false,
        icon: { type: 'icon', value: '' },
        iconColor: { type: 'color', color: '#1D2939' },
        playingIconColor: { type: 'color', color: '#1D2939' },
        eventList: [],
        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: AUDIO_VARIANT_DEFAULT_SIZE[variant]
        },
        breakPoints: []
    }
}
